<script>
import { Scatter } from 'vue-chartjs'

export default {
  name: 'scatterChart',
  extends: Scatter,
  props: ['data', 'options'],
  mounted () {
    this.renderChart(this.data, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/app/programguide/components/ScatterChart.vue